import { ISelectOption } from '../../../ui-toolkit';

export interface IAchAccountData {
  id?: string;
  name: string;
  accountNumber: string;
  routingNumber: string;
  accountType: eAccountType;
}

export enum eAccountType {
  CCD = 'CCD',
  PPD = 'PPD',
}

export const prettyAccountType: Record<eAccountType, string> = {
  [eAccountType.CCD]: 'CCD (Company)',
  [eAccountType.PPD]: 'PPD (Consumer)',
};

export const accountTypeOptions: ISelectOption[] = Object.values(eAccountType).map((type) => ({
  label: prettyAccountType[type],
  value: type,
}));
